import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useNavigate } from "react-router-dom";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { red, green } from "@mui/material/colors";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({
  handleCloseDialog,
  open1,
  singleJob,
  user,
  setUser,
}) {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    handleCloseDialog(false);
  };

  React.useEffect(() => {
    setOpen(open1);
  }, [open1]);

  const handleClose1 = () => {
    handleApply();
    setOpen(false);
    handleCloseDialog(false);
  };
  const handleApply = async () => {
    if (user?.token) {
      try {
        const { data } = await axios.post(
          `/api/user/applyJob/${singleJob._id}`
        );
        toast.success(
          "successfully applied,your CV will be reviewed and be under consideration",
          {
            position: "bottom-right",
          }
        );
        // Retrieve the current data stored in local storage
        let d = JSON.parse(localStorage.getItem("userInfo"));

        // Modify the "user" part of the data
        d.user.appliedJobs.push(singleJob._id);

        // Store the modified data back into local storage
        localStorage.setItem("userInfo", JSON.stringify(d));
        setUser(JSON.parse(localStorage.getItem("userInfo")));
      } catch (error) {
        toast.error(error.response.data.message, {
          position: "bottom-right",
        });
      }
    } else {
      toast.error("please register in order to Apply", {
        position: "bottom-right",
      });
      navigate("/login");
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Are you sure you want to Apply for this Job?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Once you applied for this job you cannot undo this action.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              bgcolor: red[500],
              color: "white",
              "&:hover": { bgcolor: red[700] },
            }}
            onClick={handleClose}
          >
            Undo
          </Button>
          <Button
            sx={{
              bgcolor: green[500],
              color: "white",
              "&:hover": { bgcolor: green[700] },
            }}
            onClick={handleClose1}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
